import { z } from 'zod';

export const emailSchema = z.string().email('Invalid email address').max(255);

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .max(128)
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
  .regex(/[0-9]/, 'Password must contain at least one number');

export const phoneSchema = z
  .string()
  .regex(/^\+[1-9]\d{6,14}$/, 'Invalid phone number format. Use E.164 format (e.g., +1234567890)');

export const otpSchema = z.string().regex(/^\d{6}$/, 'OTP must be 6 digits');

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export const cuidSchema = z.string().min(1, 'ID is required');

export const displayNameSchema = z
  .string()
  .min(2, 'Display name must be at least 2 characters')
  .max(50)
  .regex(/^[a-zA-Z0-9_\- ]+$/, 'Display name can only contain letters, numbers, spaces, hyphens, and underscores');

export const bioSchema = z.string().max(500).optional();

export const skillsSchema = z.array(z.string().min(1).max(50)).max(20);

export const languagesSchema = z.array(z.string().min(2).max(50)).max(10);

export const evmAddressSchema = z
  .string()
  .regex(/^0x[a-fA-F0-9]{40}$/, 'Invalid EVM address');

export const solanaAddressSchema = z
  .string()
  .regex(/^[1-9A-HJ-NP-Za-km-z]{32,44}$/, 'Invalid Solana address');
